var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('locationbasic',{attrs:{"locationnetworkslocations":_vm.LocationNetworksLocations,"locationCount":_vm.locationLength,"loading":_vm.loading},on:{"locationSaved":function($event){return _vm.fetchLocations()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }